import { styled } from '@mui/material';

export const TableWrap = styled('div')<{ roomCount: number }>(({ roomCount }) => ({
    display: 'grid',
    gridTemplateColumns: `50px repeat(${roomCount}, 1fr)`,
    gridAutoRows: '69px',
    width: '100%',
    overflow: 'auto',
}));

export const TimeLabel = styled('div', {
    shouldForwardProp: (prop) => !['isFirst', 'isLast', 'colorScheme'].includes(prop as string),
})<{
    isFirst: boolean;
    isLast: boolean;
    colorScheme: string;
}>(({ isFirst, isLast, colorScheme }) => {
    const isDark = colorScheme === 'dark';

    const borderRadius = (() => {
        if (isFirst) return '5px 0px 0px 0px';
        if (isLast) return '0px 0px 0px 5px';
        return '0px';
    })();
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '0.5px solid #383B40',
        height: '69px',
        minWidth: '50px',
        fontWeight: 600,
        fontSize: '8px',
        lineHeight: '10px',
        borderRadius,
        backgroundColor: isDark ? '#1F2023' : '#FFFFFF',
        color: isDark ? '#FFFFFF' : '#000000',
    };
});
